import { Component, EventEmitter, Input, Output } from '@angular/core';
import {Common} from '../../shared/common';
import {UserData} from '../../models/UserData';

@Component({
  selector: 'change-profile-popup',
  templateUrl: './change-profile-popup.component.html',
  styleUrls: ['./change-profile-popup.component.less', '../../shared/common.less']
})
export class ChangeProfilePopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Output() changeProfileEvent = new EventEmitter<number>();
  @Input() contactToUpdate: UserData | null = null;
  isFormValid: boolean = false;
  
  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  confirmChangeProfile() {
    const profileRadio = document.querySelector('input[name="profile"]:checked') as HTMLInputElement;
    const profile = parseInt(profileRadio?.value || '-1', 10);
    if (this.contactToUpdate) {
      this.changeProfileEvent.emit(profile);
    }
  }

  defineRole(profile: number): string {
    switch (profile) {
      case 0:
        return "RH";
      case 1:
        return "BV";
      case 2:
        return "SC";
      case 3:
        return "CP";
      default:
        return "";
    }
  }

  defineFullRole(profile: number): string {
    switch (profile) {
      case 0:
        return "Ressources humaines";
      case 1:
        return "Bureau de vote";
      case 2:
        return "Scrutateur";
      case 3:
        return "Chef de projet";
      default:
        return "";
    }
  }

  validateForm() {
    const profileRadio = document.querySelector('input[name="profile"]:checked') as HTMLInputElement;
    this.isFormValid = profileRadio !== null;
  }

  onChangeProfile() {
    const profileRadio = document.querySelector('input[name="profile"]:checked') as HTMLInputElement;
    const profile = parseInt(profileRadio?.value || '-1', 10);

    // Émettre l'événement avec le nouveau profil
    this.endDetailsPopup.emit(false);
    // TODO: émettre un événement pour le changement de profil
  }

  getRoleBackgroundColor(profile: number): string {
    switch (profile) {
      case 0:
        return "#D8E8FF";
      case 1:
        return "#CBFFD5";
      case 2:
        return "#E8EDF3";
      case 3:
        return "#FDE7F3";
      default:
        return "#FFFFFF";
    }
  }

  ngOnInit() {}

  /**
   * Valide le format d'une adresse email
   */
  isValidEmail(email: string): boolean {
    if (!email) {
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  }

}
